import React from 'react';
import { Reveal } from '../ui/Reveal';
import { empowerAreas } from '../../data/highlights';
export function EmpowerSection() {
  return <section aria-labelledby="empower-heading" className="bg-white" data-id="element-93" data-mp="3hzcj1bltqr0p">
      <div className="px-fluid py-section grid gap-fluid lg:grid-cols-12" data-id="element-94" data-mp="347o8hcr84alu">
        <Reveal className="lg:col-span-5" data-id="element-95" data-mp="387ym9bl9c5b9">
          <h2 id="empower-heading" className="text-h2 font-extrabold text-brand-navy" data-id="element-96" data-mp="388rllrhvzsjd">
            <span className="text-brand-blue" data-id="element-97" data-mp="3vz44fxeo79oq">Empower.</span> It’s the word I live by.
          </h2>
        </Reveal>
        <div className="lg:col-span-7" data-id="element-98" data-mp="4qq9h65dzvne">
          <Reveal delay={0.05} data-id="element-99" data-mp="3mxecmqgvm8qf">
            <p className="text-lead max-w-[52ch]" data-id="element-100" data-mp="3mw2zw15gdqn6">
              To me, empowering someone means giving them the ability to accomplish things they didn’t think they had
              the ability to do. Sometimes that’s in business. Sometimes it’s in life. Either way, it’s what gets me up
              in the morning.
            </p>
          </Reveal>
          <ul className="mt-[clamp(2.5rem,4vw,5rem)] grid gap-4 sm:grid-cols-3 sm:gap-[clamp(1rem,1.5vw,2rem)]" data-id="element-101" data-mp="24l5xdi698w0r">
            {empowerAreas.map(({
            label,
            icon: Icon
          }, i) => <Reveal as="li" key={label} delay={0.08 + i * 0.05} className="radius-fluid bg-brand-mist p-[clamp(1.25rem,2vw,2.5rem)]" data-id="element-102" data-mp="1znw23lw6pq50" data-mpi={i}>
                <span className="flex h-[clamp(2.75rem,3.4vw,4.5rem)] w-[clamp(2.75rem,3.4vw,4.5rem)] items-center justify-center rounded-full bg-brand-navy text-white" data-id="element-103" data-mp="29kihvw9nlr06">
                  <Icon className="h-[45%] w-[45%]" aria-hidden="true" data-id="element-104" data-mp="2nhxfhoa29538" />
                </span>
                <h3 className="text-h3 mt-[clamp(1rem,1.6vw,2rem)] font-bold text-brand-navy" data-id="element-105" data-mp="2iiuhgnshzz4r">{label}</h3>
              </Reveal>)}
          </ul>
        </div>
      </div>
    </section>;
}